import { InjectionToken } from '@angular/core';
import { ImgWebConfig } from './types';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const IMG_WEB_CONFIG: InjectionToken<ImgWebConfig> = new InjectionToken<ImgWebConfig>('imgWebConfig');
